/**
 * `Intl.NumberFormat` is not free to build, and a list of sets formats the
 * same way hundreds of times, so each locale-and-options pair is built once.
 */
const cache = new Map();
function numberFormat(locale, maximumFractionDigits) {
    const key = `${locale}|${maximumFractionDigits}`;
    let format = cache.get(key);
    if (!format) {
        format = new Intl.NumberFormat(locale, {
            maximumFractionDigits,
            minimumFractionDigits: 0,
        });
        cache.set(key, format);
    }
    return format;
}
/** A load in kilograms, unit-less: 72.5 → "72,5" (pt-BR) / "72.5" (en-US). */
export function formatKg(n, locale, { maxFractionDigits = 1 } = {}) {
    return numberFormat(locale, maxFractionDigits).format(n);
}
/** A volume in kilograms, shown in tonnes: 2200 → "2,2 t" / "2.2 t". */
export function formatTonnes(kg, locale) {
    return `${formatKg(kg / 1000, locale)} t`;
}
/** A whole number with grouping: 1234 → "1.234" / "1,234". */
export function formatInt(n, locale) {
    return numberFormat(locale, 0).format(n);
}
//# sourceMappingURL=number.js.map